<template>
    <div v-pml-block="isLoading" class="bg_load_null">
        <pml-pagination :source="pagination" @navigate="fetchList"></pml-pagination>
        <div style="min-height: 100px;">
            <div class="card-box m-b-10 p-10 relative card_color_left">
                <div class="table-box table_fixed table_deals">
                    <div class="table-detail w_30">
                        <div class="clearfix">
                            <pml-checkbox v-model="selectAll" @input="isSelected" :label="$t('select_all')" :disabled="list.length == 0"></pml-checkbox>
                        </div>
                    </div>
                </div>
            </div>
            <PmlItem v-for="item in list" :key="item.id" :item="item"></PmlItem>
            <div v-if="!list.length" class="text-center p-t-40"><i class="fa fa-exclamation-triangle"></i> {{ $t('no_records_found') }}</div>
        </div>
        <pml-pagination :source="pagination" @navigate="fetchList"></pml-pagination>
    </div>
</template>

<script>
    import PmlItem from './Item.vue'
    import bus from 'utils/events/bus'

    export default {
        name: 'DealsList',
        components: { PmlItem },
        data () {
            return {
                pagination: {},
                isLoading: false,
                selectAll: false
            }
        },
        created () {
            bus.$on('paginationRefreshDeals', (data) => { this.pagination = data })
            bus.$on('listLoadingDeals', (bool) => { this.isLoading = bool })
        },
        destroyed () {
            bus.$off('paginationRefreshDeals')
            bus.$off('listLoadingDeals')
        },
        computed: {
            list () {
                return this.pagination.data || []
            }
        },
        methods: {
            fetchList (page = 1) {
                bus.$emit('doFilterDeals', page)
            },
            isSelected (val) {
                val ? this.selectedAll() : this.unselectedAll()
            },
            selectedAll () {
                const newIds = this.pagination.data.map(item => item.id)
                bus.$emit('addSelected', newIds)
                bus.$emit('selectedAll', true)
            },
            unselectedAll () {
                const ids = this.pagination.data.map(item => item.id)
                bus.$emit('removeSelected', ids)
                bus.$emit('selectedAll', false)
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/emails/massive/components/List.vue